import { createReducer, on } from '@ngrx/store';

import * as SimsearchActions from './simsearch.actions';
import { SimsearchState } from './simsearch.state';

export const initialSimsearchState: SimsearchState = {};

export const simsearchReducer = createReducer(
  initialSimsearchState,
  on(
    SimsearchActions.simsearchStartLoadVehiclesAction,
    (state, action): SimsearchState => ({
      ...state,
      vehicleId: action.payload.vehicleId
    })
  ),
  on(
    SimsearchActions.simsearchFinishLoadVehiclesAction,
    (state, action): SimsearchState => ({
      ...state,
      vehicleConfiguration: action.payload.vehicleConfiguration,
      similarVehicles: action.payload.similarVehicles,
      footnotes: action.payload.footnotes
    })
  ),
  on(SimsearchActions.simsearchClearStateAction, (state, action): SimsearchState => initialSimsearchState)
);
